import React from "react";
import { BiSupport } from "react-icons/bi";
import "./styles.scss";

const FloatingButton = () => {
  return (
    <div
      style={{
        // height: "60px",
        // width: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bottom: "10%",
        boxShadow: "0px 2px 0px #C0C0C0",
        // borderRadius: 50,
      }}
    >
      <a
        href="https://wavecards.com.au/support"
        target="_blank"
        rel="noreferrer"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BiSupport className="floatingIcon" />
          <p className="contactSupport">Contact Support</p>
        </div>
      </a>
    </div>
  );
};

export default FloatingButton;
